import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Slider from "react-slick";
import Typography from "@mui/material/Typography";
import "slick-carousel/slick/slick.css";
import Container from "@mui/material/Container";
import { songPageGTMCTAClick } from "../../util/gtmutil";
import auth from "../Layout/util/auth";

import { useTimer } from "../../src/hooks/useTimer";
import eventBus from "../../util/eventBus";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import OutlinedButton from "../Buttons/OutlinedButton";
const useStyles = makeStyles((theme) => ({
  fanBnner: {
    position: "relative",
    "& .bannerTop": {
      background: "url('/images/newHome/banner.svg')",
      height: "75vh",
      backgroundRepeat: "no-repeat",
      width: "100%",
      backgroundSize: "cover",
      // backgroundAttachment: "fixed",
      backgroundPosition: "center",
      "@media (max-width:1024px)": {
        backgroundAttachment: "scroll",
      },
      "@media (max-width:767px)": {
        backgroundAttachment: "scroll",
        height: "500px",
      },
      "& img": {
        width: "100%",
      },

      "& .fan__IconAnimation": {
        width: "242px",
        top: "34% !important",
        right: "9% !important",
        position: "absolute !important",
        left: "auto !important",
        "& img": {
          height: "142px",
          width: "142px",
        },
        "@media (max-width:1500px)": {
          right: "0 !important",
        },
        "@media (max-width:1024px)": {
          display: "none !important",
        },
        "@media (max-width:767px)": {
          display: "none !important",
        },
      },
      "& .fan__IconAnimation2": {
        width: "242px",
        top: "30% !important",
        left: "9% !important",
        position: "absolute !important",
        "& img": {
          height: "157px",
          width: "125px",
        },
        "@media (max-width:1024px)": {
          display: "none !important",
        },
        "@media (max-width:767px)": {
          display: "none !important",
        },
      },
      "& .fan__IconAnimation3": {
        width: "213px",
        top: "auto !important",
        left: "18% !important",
        position: "absolute !important",
        bottom: "5% !important",

        "@media (max-width:1440px)": {
          bottom: "4% !important",
        },
        "@media (max-width:1024px)": {
          display: "none !important",
        },
        "@media (max-width:767px)": {
          display: "none !important",
        },
      },
      "& .fan__IconAnimation4": {
        width: "100px",
        left: "15% !important",
        right: "0 !important",
        position: "absolute !important",
        textAlign: "center",
        bottom: "11% !important",
        margin: "auto !important",
        top: "auto !important",
        "@media (max-width:1440px)": {
          bottom: "0% !important",
        },
        "@media (max-width:1024px)": {
          display: "none !important",
        },
        "@media (max-width:767px)": {
          display: "none !important",
        },
      },
      "& .fan__IconAnimation5": {
        width: "100px",
        position: "absolute !important",
        top: "9px !important",
        left: "auto !important",
        right: "82px !important",
        textAlign: "center",
        margin: "auto !important",
        "@media (max-width:1024px)": {},
        "@media (max-width:767px)": {
          width: "69px",
          top: "63px !important",
          right: "0px !important",
        },
      },
      "& .fan__IconAnimation6": {
        width: "65px",
        left: "133px !important",
        right: "auto !important",
        position: "absolute !important",
        top: "9px !important",
        margin: "auto !important",

        "@media (max-width:767px)": {
          top: "-12px !important",
          width: "40px",
          left: "35px !important",
        },
      },
    },
  },

  fanSliderHeading: {
    position: "absolute",
    top: "80px",
    left: "0",
    right: "0",
    color: "#fff",
    textAlign: "center",
    "@media (max-width:767px)": {
      top: "54px",
    },
    "& .top__Heading": {
      width: "1000px",
      position: "relative",
      margin: "auto",
      "@media (max-width:1024px)": {
        width: "100%",
      },
      "@media (max-width:767px)": {
        width: "100%",
      },
      "& h1": {
        fontSize: "78px",
        fontWeight: "900",
        lineHeight: "96px",
        background:
          "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
        "-webkitBackgroundClip": "text",
        "-webkitTextFillColor": "transparent",
        backgroundClip: "text",
        textFillColor: "transparent !important",

        "@media (max-width:1024px)": {
          fontSize: "65px",
          lineHeight: "80px",
        },
        "@media (max-width:767px)": {
          fontSize: "34.6667px",
          lineHeight: "45px",
        },
      },
      "& h2": {
        fontSize: "78px",
        fontWeight: "900",
        lineHeight: "96px",

        "@media (max-width:1024px)": {
          fontSize: "65px",
          lineHeight: "80px",
        },
        "@media (max-width:767px)": {
          fontSize: "34.6667px",
          lineHeight: "45px",
        },
      },
    },
    "& p": {
      fontWeight: "400",
      fontSize: "20px",
      margin: "30px 0 0",
      "@media (max-width:1024px)": {
        margin: "20px 0 0",
      },
      "@media (max-width:767px)": {
        fontSize: "15px",
        width: "260px",
        margin: "25px auto",
      },
    },

    "& .fan__JoincommunityButton": {
      transition: "all 0.5s ease",
      background:
        "linear-gradient(93.89deg, #E14084 -7.45%, #3454FA 76.4%, #54B5BB 150.28%)",
      border: "none",
      fontSize: "16px",
      width: "148px",
      height: "60px",
      borderRadius: "100px",
      display: "inline-block",
      backgroundColor: "transparent",
      color: "#fff",
      marginTop: "30px",
      marginRight: "25px",
      "@media (max-width:1024px)": {
        marginTop: "15px",
      },
      "@media (max-width:767px)": {
        width: "145px",
        height: "45px",
        marginTop: "0",
      },
      "&:hover": {
        background: "rgb(52,84,250)",
        background:
          "linear-gradient(90deg, rgba(52,84,250,0.9139005944174545) 33%, rgba(225,64,132,0.8102591378348214) 77%) !important",
        boxShadow: "0px 0px 31px 3px #3659f6",
        border: "none",
      },
    },
  },
  Countdown__Timer: {
    "& .timebox__wrapper": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "35px",
    },
    "& .single__box": {
      textAlign: "center",
      paddingLeft: "20px",
      "& h1": {
        margin: "0px",
        fontSize: "35px",
        fontWeight: "700",
        color: "white",
      },
      "& p": {
        margin: "0px",
        color: "white",
        whiteSpace: "nowrap",
        fontSize: "13px",
      },
    },
    "& .songprofile__Name": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "30px",
      "& .singer___thumb": {
        "& img": {
          width: "65px",
          height: "65px",
          borderRadius: "13px",
          border: "2px solid #ffffff",
          display: "block",
        },
      },
      "& .singer__SongDetails": {
        textAlign: "left",
        paddingLeft: "15px",
        "& h2": {
          color: "#fff",
          fontSize: "20px",
          fontWeight: "500",
        },
        "& p": {
          color: "#fff",
          fontSize: "13px",
          margin: "0",
        },
        "& h6": {
          fontSize: "13px",
          lineHeight: "17px",
        },
      },
    },
  },
  timebox__wrapperSlider: {
    maxWidth: "700px",
    marginBottom: "30px",
  },
  btnContainer: {
    transition: "all 0.5s ease",
    background:
      "linear-gradient(93.89deg, #E14084 -7.45%, #3454FA 76.4%, #54B5BB 150.28%)",
    border: "none",
    fontSize: "16px",
    paddingInline: "30px",
    height: "60px",
    borderRadius: "100px",
    display: "inline-block",
    backgroundColor: "transparent",
    color: "#fff",
    textTransform: "none",
    cursor: "pointer",
    "@media (max-width:1024px)": {
      marginTop: "15px",
    },
    "@media (max-width:767px)": {
      width: "145px",
      height: "45px",
      marginTop: "0",
    },
    "&:hover": {
      background: "rgb(52,84,250)",
      background:
        "linear-gradient(90deg, rgba(52,84,250,0.9139005944174545) 33%, rgba(225,64,132,0.8102591378348214) 77%) !important",
      boxShadow: "0px 0px 31px 3px #3659f6",
      border: "none",
    },
  },
  bannerBtn: {
    width: "380px",
    "@media (max-width:480px)": {
      columnGap: "10px !important",
    },
  },
}));

const Banner = (data) => {
  const r = auth();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state?.user);
  useEffect(() => {
    let scene = document.getElementById("js-scene");
    let parallax = new Parallax(scene);
  }, []);

  const classes = useStyles();

  const fanHeadingSlider = {
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    draggable: false,
  };
  const CountdownSlider = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    dots: false,
    arrows: false,
    autoplaySpeed: 0,
    speed: 9000,
    cssEase: "linear",
    pauseOnHover: true,
  };
  const handleHowItWorks = () => {
    songPageGTMCTAClick(
      r,
      "Home Page",
      "banner",
      "How it Works",
      "loggedIn",
      "Guest",
      "Home Page"
    );
    window.location.replace("/#Howitwork");
  };

  const [count, setCount] = useState(0);
  const handleJoinNow = () => {
    if (isEmpty(r?.token)) {
      eventBus?.dispatch("openLoginModal", {
        function_name: "uniqueCommunity",
      });
    } else if (!userData?.mobile) {
      eventBus?.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    }
  };

  const SongLaunchBannerSlider = ({
    artistsName,
    songName,
    songimage,
    launchDate,
  }) => {
    const [days, hours, minutes, seconds] = useTimer(launchDate);
    return (
      <div className={classes.Countdown__Timer}>
        <div className="timebox__wrapper">
          <div className="songprofile__Name">
            <div className="singer___thumb">
              <img src={songimage} alt="artists Image" />
            </div>
            <div className="singer__SongDetails">
              <Typography variant="body1">New Song Launch</Typography>
              <Typography variant="h2">{artistsName}</Typography>
              <Typography variant="h6">{songName}</Typography>
            </div>
          </div>
          <div className="single__box">
            <Typography variant="h1">{days}</Typography>
            <Typography variant="body1">Days</Typography>
          </div>
          <div className="single__box">
            <Typography variant="h1">{hours}</Typography>
            <Typography variant="body1">Hours</Typography>
          </div>
          <div className="single__box">
            <Typography variant="h1">{minutes}</Typography>
            <Typography variant="body1">Minutes</Typography>
          </div>
          <div className="single__box">
            <Typography variant="h1">{seconds}</Typography>
            <Typography variant="body1">Seconds</Typography>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={classes.fanBnner} id="js-scene">
        <div className="bannerTop">
          <div className={classes.fanSliderHeading}>
            {/* <Container xs={6} className={classes.timebox__wrapperSlider}>
              <Slider className={classes.SlickSlider} {...CountdownSlider}>
                {data?.songLaunchdata &&
                  data?.songLaunchdata?.map((item) => {
                    return (
                      <>
                        <SongLaunchBannerSlider
                          artistsName={
                            item?.attributes?.artists?.data?.[0]?.attributes
                              ?.name
                          }
                          songimage={
                            item?.attributes?.additional_media_image?.data?.[0]
                              ?.attributes?.formats?.small?.url
                          }
                          songName={item?.attributes?.Title}
                          launchDate={item?.attributes?.lauch_date}
                        />
                      </>
                    );
                  })}
              </Slider>
            </Container> */}

            <div className="top__Heading">
              <Slider className={classes.SlickSlider} {...fanHeadingSlider}>
                <div className="sliderIteam">
                  <Typography variant="h1">Trade & Earn</Typography>
                  <Typography variant="h2"> Multiple Folds</Typography>
                </div>

                <div className="sliderIteam">
                  <Typography variant="h1">Earn Royalty</Typography>
                  <Typography variant="h2">With Privileges</Typography>
                </div>
              </Slider>
              <div className="fan__IconAnimation5 layer" data-depth="0.1">
                <img
                  src={"/images/home/Headphone1.png"}
                  alt="HeadPhone image"
                />
              </div>
              <div className="fan__IconAnimation6 layer" data-depth="0.1">
                <img
                  src={"/images/newHome/MusicalNote.png"}
                  alt="Musical Note"
                />
              </div>
            </div>
            <p>
              Own a piece of your favorite songs and earn royalties for every
              stream.
            </p>
            <Box
              className="bannerBtn"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
                columnGap: "30px",
                marginTop: "30px",
              }}
            >
              {!r?.token && (
                <button
                  className={classes.btnContainer}
                  onClick={() => handleJoinNow()}
                >
                  Join Now
                </button>
              )}

              <Box className="Custome__buttonFan">
                <OutlinedButton
                  buttonText="How it Works"
                  handleClick={handleHowItWorks}
                />
              </Box>
            </Box>
          </div>

          <div className="fan__IconAnimation layer" data-depth="0.1">
            <img src={"/images/newHome/Dancecircle.png"} alt="Dance cricle" />
          </div>
          <div className="fan__IconAnimation2 layer" data-depth="0.1">
            <img src={"/images/newHome/SingerCircle.png"} alt="singer Circle" />
          </div>
          <div className="fan__IconAnimation3 layer" data-depth="0.1">
            <img
              src={"/images/newHome/HooterNew.png"}
              alt="hooter image"
              style={{ width: "150px" }}
            />
          </div>
          <div className="fan__IconAnimation4 layer" data-depth="0.1">
            <img
              src={"/images/newHome/Microphone.png"}
              alt="MicroPhone image"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
